import * as React from "react";
const SvgHMobiledataOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z" />
  </svg>
);
export default SvgHMobiledataOutlined;
